export default {"src":"/_next/static/media/product_arrow_down.d8ebb600.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};